module.exports = __webpack_public_path__ + "static/spaceKitchenMobile@x1-f865f5a2fa57adbce7476c0a97ef594f.png";